import service from './index'

const resource = service.resource('runners{/id}')

export default {
  get (id) {
    return resource.get({id: id})
  },
//   create (runner) {
//     return resource.save({}, runner)
//   },
  update (runnerData) {
    return resource.update(runnerData)
  },
  
}



// WEBPACK FOOTER //
// ./src/services/runner.js